<template xmlns="http://www.w3.org/1999/html">

  <div class="package">
    <div class="intelligentAgent">
      <div class="internalLayer">
        <div class="login">
          <div class="logo" v-if="showMessage.length!==0">
            <img class="img" src="/favicons.ico" alt=""/>
            <h1 class="welcome-text">欢迎使用泰山科技大市场智能体</h1>

          </div>
          <div :class="showMessage.length!==0?'right':'noRight'">

            <el-button type="success" class="textClass" @click="handleNewChat">
              新建对话
            </el-button>

            <div class="view-count-badge">
              <i class="el-icon-view"></i>
              <span>{{ viewCount }} 浏览</span>
            </div>
            <div class="no_login" v-if="!loginTrue" @click="loginUp()">
              登录/注册
            </div>
            <div class="no_loginRight" v-if="loginTrue">
              <span class="logout" @click="logout" v-if="loginTrue">退出</span>
            </div>
          </div>
        </div>

        <div :class="showMessage.length !== 0 ? 'answer' : 'noAnswer'" ref="messageContainer">
          <div class="overflow">
            <div class="chat-container">
              <div class="messages" ref="messagesContainer">
                <div
                    v-for="(msg, index) in showMessage"
                    :key="index"
                    class="message-item"
                    :class="msg.type"
                    v-if="showMessage.length !== 0">
                  <!--                  <div class="avatar" :class="msg.type">-->
                  <!--                    {{ msg.type === 'user' ? '我' : "AI" }}-->
                  <div class="avatar" :class="msg.type">
                    <img v-if="msg.type !== 'user'" src="/favicons.ico" alt="AI Logo" class="ai-logo">
                    <span v-else>我</span>
                    <!--                    </div>-->
                  </div>
                  <div class="message-content">
                    <div class="message-text" v-html="msg.assistant"></div>
                  </div>
                </div>
              </div>
            </div>


            <div class="notData" v-if="showMessage.length<=0">
              <img class="img" src="/favicons.ico" alt=""/>
              <h1>欢迎使用泰山科技大市场智能体</h1>
            </div>
          </div>
        </div>


        <!--      //数据部分旧的-->
        <!--      <div :class="showMessage.length!==0?'answer':'noAnswer'" ref="messageContainer">-->
        <!--        <div class="questionBubble" v-if="showMessage.length!==0" v-for="(item, index) in showMessage" :key="index">-->
        <!--          <div class="questionClass" v-if="item.question != null"><span class="questionSpan">{{-->
        <!--              item.question-->
        <!--            }}</span>-->
        <!--          </div>-->
        <!--          <div v-if="item.output!=null" id="text" class="content" v-html="item.output"></div>-->
        <!--        </div>-->

        <!--      </div>-->

        <div class="input-section">
          <div class="input-wrapper">
            <el-input
                type="textarea"
                :rows="4"
                v-model="message"
                placeholder="请输入内容 ( Enter 发送)"
                resize="none"
                class="input-box"
                @keydown.native="handleEnter"
            ></el-input>
            <el-button
                type="primary"
                class="send-btn"
                @click="send">
              发送消息
            </el-button>
          </div>
        </div>
        <!--      <div class="message">-->
        <!--        <div class="input-container">-->
        <!--          <el-input-->
        <!--              class="messageInput"-->
        <!--              type="textarea"-->
        <!--              v-model="message"-->
        <!--              :rows="9"-->
        <!--              placeholder="请输入内容(Alt + Enter换行)"-->
        <!--              @keydown.native="handleEnter"-->
        <!--          />-->
        <!--          <span class="send-button" @click="send" :class="{ 'disabled': isDisabled }"-->
        <!--                :style="{ pointerEvents: isDisabled ? 'none' : 'auto' }">-->
        <!--          发送消息-->
        <!--          </span>-->
        <!--        </div>-->
        <!--&lt;!&ndash;        <span class="prompt">欢迎使用泰山科技大市场智能体</span>&ndash;&gt;-->
        <!--      </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {getToken} from "@/api/http";
import {nextTick} from "vue";

export default {
  data() {
    return {
      viewCount:0,
      messageListNew: [],
      lets: [],
      messageList: [],
      loginTrue: '',
      //是否终止读取
      shouldStop: false,
      //是否禁用
      isDisabled: false,
      //展示的问题
      showMessage: [],
      // output: "",
      url: "wss://kejichengguo.tskjdsc.com/WebSocketIntelligentAgent/message",
      // url: "ws://localhost:8945/WebSocketIntelligentAgent/message",
      message: "",
      text_content: "",
      ws: null,

    };
  },

  watch: {
    showMessage: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true
    }
  },

  mounted() {
    this.getTokeNew();
    this.scrollToBottom();
  },
  created() {
    this.getToken();
    this.login();
    this.getTokeNew();
    this.join();
  },

  methods: {

    // scrollToBottom() {
    //   const el = this.$refs.outputContainer;
    //   if (!el) return;
    //
    //   el.scrollTop = el.scrollHeight;
    // },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messagesContainer) {
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
        }
      });
    },

    handleEnter(event) {
      // 判断是否按下 Alt + Enter
      if (event.altKey && event.key === "Enter") {
        // 插入换行符
        this.message += "\n";
        event.preventDefault(); // 阻止默认行为（避免触发其他事件）
      }
      // 判断是否按下 Enter 键且没有按住 Alt
      else if (event.key === "Enter" && !event.altKey && !this.isDisabled) {
        if (this.message == null) {
          alert("内容为空不允许提交")
        }
        event.preventDefault(); // 阻止默认的换行行为
        this.send(); // 调用发送消息方法
      }
    },


    join() {
      const wsuri = this.url;
      this.ws = new WebSocket(wsuri);
      const self = this;

      this.ws.onopen = function (event) {
        self.text_content = self.text_content + "已经打开连接!" + "\n";
      };

      this.ws.onmessage = function (event) {
        if (self.showMessage.length !== 0) {
          // 处理新消息
          const cleanData = event.data.replace("end", "").replaceAll("{", "").replaceAll("}", "").replaceAll("\"", "");

          // 更新最后一条消息
          if (self.showMessage[self.showMessage.length - 1].assistant === "正在思考...") {
            self.showMessage[self.showMessage.length - 1].assistant = "";
          }
          self.showMessage[self.showMessage.length - 1].assistant += cleanData;

          // 确保滚动到底部
          self.$nextTick(() => {
            const container = document.getElementById('text');
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          });

          // 处理结束标记
          if (event.data.includes("end")) {
            self.lets = {
              role: "assistant",
              content: self.showMessage[self.showMessage.length - 1].assistant,
              type: 'bot',
              assistant: self.showMessage[self.showMessage.length - 1].assistant,
            };
            self.scrollToBottom(); // 添加这行

            // 再次确保滚动
            self.$nextTick(() => {
              const container = document.getElementById('text');
              if (container) {
                container.scrollTop = container.scrollHeight;
              }
            });
          }
        }
      };

      this.ws.onclose = function (event) {
        self.text_content = self.text_content + "已经关闭连接!";
      };
    },

    // join() {
    //   const wsuri = this.url;
    //   this.ws = new WebSocket(wsuri);
    //   const self = this;
    //
    //   this.ws.onopen = function (event) {
    //     self.text_content = self.text_content + "已经打开连接!" + "\n";
    //   };
    //
    //
    //   this.ws.onmessage = function (event) {
    //     console.log("self.showMessage", self.showMessage);
    //     if (self.showMessage.length !== 0) {
    //       if (self.showMessage[self.showMessage.length - 1].assistant === "正在思考...") {
    //         self.showMessage[self.showMessage.length - 1].assistant = "";
    //         // 安全滚动
    //         this.$nextTick(this.scrollToBottom);
    //       }
    //
    //       self.scrollToBottom();
    //       self.showMessage[self.showMessage.length - 1].assistant += event.data.replace("end", "").replaceAll("{","").replaceAll("}","").replaceAll("\"","").replaceAll(":","");
    //       self.scrollToBottom();
    //       nextTick(() => {
    //         self.scrollToBottom();
    //       });
    //       // 安全滚动
    //       // this.$nextTick(this.scrollToBottom);
    //       // self.showMessage[self.showMessage.length ] += event.data.replace("end", "");
    //       console.log("self.showMessage", self.showMessage);
    //       if (event.data.includes("end")) {
    //         self.lets = {
    //           "role": "assistant",
    //           "content": self.showMessage[self.showMessage.length - 1].assistant,
    //           "type": 'bot',
    //           "assistant": self.showMessage[self.showMessage.length - 1].assistant,
    //         };
    //         const messageCopy = {...self.lets};
    //
    //         // 滚动到底部
    //         const outputEl = document.getElementById('output-container'); // 替换为您的容器ID
    //         outputEl.scrollTop = outputEl.scrollHeight;
    //         console.log(" self.messageList", self.messageList);
    //       }
    //     }
    //   };
    //
    //   this.ws.onclose = function (event) {
    //     self.text_content = self.text_content + "已经关闭连接!";
    //   };
    // },
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const container = this.$refs.messageContainer;
    //     container.scrollTop = container.scrollHeight;
    //   });
    // },

    exit() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },
    send() {
      const token = localStorage.getItem('token')
      if (token == null) {
        this.$message({
          message: '您当前未登录账号，请登录或注册账号后进行查询',
          type: 'error',
          duration: 5000,
          showClose: true,
          offset: 200
        })
      } else {
        const self = this; // 保存当前上下文
        console.log("------------=============----------------")
        if (self.ws) {
          console.log("this.ws.", self.ws)
          console.log("this.message.", self.message)
          self.showMessage.push({
            question: self.message,
            output: "正在思考...", // 模拟的输出
            assistant: self.message,
            type: "user"
          });
          const message = {
            "role": "assistant",
            "content": "正在思考...",
            "type": 'assistant',
            "assistant": "正在思考...",
          }
          self.showMessage.push(message);
          self.scrollToBottom(); // 添加这行
          const userMessage = {
            "role": "user",
            "content": self.message
          }
          console.log("userMessage", userMessage);
          let param = null;
          if (self.messageList.length !== 0) {
            self.messageList.push(userMessage)
            // 深拷贝原始数据

// 然后进行转换为字符串
            param = JSON.stringify(self.messageList)
          } else {
            let params = [{
              "role": "user",
              "content": self.message
            }]
            param = JSON.stringify(params)
          }
          self.messageListNew.push(param);
          console.log("messageListaaa", self.messageList);
          self.ws.send(param);
          self.textShow = true;
          self.message = "";
          //判断是否终止
          self.shouldStop = false;
        } else {
          alert("未连接到服务器");
        }
      }
    },

    //滚动底部
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const container = this.$refs.messageContainer;
    //     console.log(" container.scrollTop", container.scrollTop)
    //     console.log(" container.scrollHeight", container.scrollHeight)
    //     container.scrollTop = container.scrollHeight;
    //   });
    // },

    login() {
      const token = localStorage.getItem('token')
      if (token == null) {
        this.$message({
          message: '您当前未登录账号，请登录或注册账号后进行查询',
          type: 'error',
          duration: 5000,
          showClose: true,
          offset: 200
        })
      }
    },
    //跳转登录
    loginUp() {
      this.$router.push({path: '/login', query: {type: "3"}})
    },

    //退出
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({path: '/login', query: {type: "3"}})
      // var item = sessionStorage.getItem("token");

    },
    getToken() {
      if (localStorage.getItem('token')) {
        this.loginTrue = true
        this.showPage = true
      } else {
        this.loginTrue = false
        // this.$router.push('/login')
      }
    },
    getTokeNew() {
      getToken().then(response => {
        console.log("e", response.data);
        this.token = response.data;
      })
    },

    handleNavClick(type) {
      console.log('导航点击:', type);
    },
    handleNewChat() {
      window.location.reload()
      console.log('新建对话');
      this.inputContent = '';
    },
    handleSend() {
      if (!this.inputContent.trim()) return;
      console.log('发送消息:', this.inputContent);
      this.inputContent = '';
    },
    handleExit() {
      console.log('退出系统');
      // 这里可以添加退出登录逻辑
    }
  }

};

</script>
<style scoped lang="scss">

.send-btn {
  position: absolute;
  right: 10px;
  top: 25px;
  z-index: 2;
  padding: 8px 20px;
  border-radius: 15px
}

.input-section {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 17%);
  height: 70px;
  margin-top: 5px;
}

.input-wrapper {
  position: relative;
}


.input-box  .el-textarea__inner {
  padding-right: 90px !important;
  border: none;
  background: #f5f7fa;
}

.a {
  width: 100%;
  display: flex;
  align-items: baseline;
}

.package {
  background: #00000003;
  width: 100%;
}

.intelligentAgent {
  width: 50%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  height: 100vh; /* 页面高度 */
  margin: auto;

  .internalLayer {
    display: flex;
    flex-direction: column;
    flex-grow: 1; /* 让内部层级占用剩余的空间 */
  }

  .message {
    //width: 80%; /* 占用屏幕宽度的 80% */
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 20px;
    flex-shrink: 0; /* 防止被压缩 */


    /* 输入框和按钮容器 */
    .input-container {
      position: relative; /* 设置相对定位，用于子元素的绝对定位 */
      width: 100%;
    }

    /* 输入框样式 */
    ::v-deep .el-textarea__inner {
      width: 100%; /* 占满父容器的宽度 */
      height: auto; /* 自动高度 */
      box-sizing: border-box;
      border-radius: 8px; /* 圆角效果 */
      padding-bottom: 40px; /* 为按钮留出空间 */
      font-size: 25px;
      margin-top: 0 !important;
      border: none; /* 禁用边框 */
    }

    /* 发送消息样式 */
    .send-button {
      position: absolute; /* 绝对定位 */
      bottom: 50px; /* 距离底部 10px */
      right: 10px; /* 距离右侧 10px */
      padding: 5px 10px; /* 文字内边距 */
      background-color: #1890ff; /* 蓝色背景 */
      color: #000000; /* 白色文字 */
      border-radius: 4px; /* 圆角效果 */
      cursor: pointer; /* 鼠标悬停时显示手型 */
      font-size: 14px; /* 字体大小 */
      z-index: 1; /* 确保文字在输入框上方 */
    }

    /* 鼠标悬停效果 */
    .send-button:hover {
      background-color: #40a9ff; /* 更亮的蓝色 */
    }

    .messageInput {
      margin-top: auto; /* 固定在底部 */
      border-radius: 8px; /* 圆角 */
      padding: 10px; /* 内边距 */
      //width: 80%; /* 确保宽度占满父元素 */
    }

    .prompt {
      display: flex;
      justify-content: center;
    }
  }

  .send-button {
    position: absolute; /* 绝对定位 */
    bottom: 10px; /* 距离底部 10px */
    right: 10px; /* 距离右侧 10px */
    padding: 5px 10px; /* 文字内边距 */
    background-color: #1890ff; /* 蓝色背景 */
    color: #fff; /* 白色文字 */
    border-radius: 4px; /* 圆角效果 */
    cursor: pointer; /* 鼠标悬停时显示手型 */
    font-size: 14px; /* 字体大小 */
    z-index: 1; /* 确保文字在输入框上方 */
  }

  .answer {
    flex-grow: 1; /* 让 answer 部分占据剩余的 80% */
    overflow-y: auto; /* 当内容过多时，允许滚动 */
    height: 80%;
    //background-color: #ffffff;
    width: 100%;
    margin: 20px auto; /* 居中显示 */
    max-height: 65vh; /* 最大高度为视口高度的 80% */
    box-sizing: border-box; /* 确保 padding 和 border 不影响宽度 */
    border-radius: 20px;
    text-align: center;
    scrollbar-color: var(--main-surface-tertiary) transparent;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .noAnswer {
    flex-grow: 1; /* 让 answer 部分占据剩余的 80% */
    overflow-y: auto; /* 当内容过多时，允许滚动 */
    height: 80%;
    width: 100%;
    margin: 20px auto; /* 居中显示 */
    max-height: 73vh; /* 最大高度为视口高度的 80% */
    box-sizing: border-box; /* 确保 padding 和 border 不影响宽度 */
    border-radius: 20px;
    text-align: center;
    scrollbar-color: var(--main-surface-tertiary) transparent;
  }

  .img {
    width: 200px;
    height: 200px;
    margin-left: -30px;
  }

  .right {
    display: flex; /* 使用 Flexbox 布局 */
    justify-content: space-between; /* 左右两端对齐 */
    align-items: center; /* 垂直居中对齐 */
    margin-bottom: 10px; /* 与下方按钮保持间距 */
    .no_loginRight {
      align-self: flex-start; /* 调整到顶部 */
      //margin-top: -100px !important;
    }
  }

  .noRight {
    align-items: center; /* 垂直居中对齐 */
    margin-bottom: 10px; /* 与下方按钮保持间距 */
    display: flex;
    margin-top: 20px;
  }

  .content {
    max-height: 100%; /* 继承父容器的最大高度 */
    padding: 10px; /* 内边距，可根据需要调整 */
    box-sizing: border-box; /* 确保 padding 不影响宽度和高度 */
    word-wrap: break-word; /* 自动换行 */
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 60px;
    position: relative;
    width: 100%;
    will-change: opacity, transform;
    background: #d9d9d9;
    border: 1px solid #c0c4cc;
  }

  .notData {
    display: flex;
    justify-self: center;
    align-content: center;
    text-align: center;
    font-size: 20px;
    align-items: center; /* 垂直方向居中对齐 */
    gap: 10px; /* 图片和文字之间的间距 */

    margin-top: 280px;
    margin-left: 12%;
  }


  .questionClass {
    font-size: 20px;
    display: flex;
    justify-self: right;
    background-color: #e0dfff;
    border-radius: 12px;
    line-height: 24px;
    max-width: 100%;
    padding: 12px 16px;
    white-space: pre-wrap;
    will-change: opacity, transform;
    margin-top: 30px;
    margin-bottom: 50px;

    .questionSpan {
      margin-left: 10px;
      margin-right: 10px;
    }
  }

}

::v-deep .el-textarea__inner {
  height: 80px !important;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.49);
  border: none;
}

.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
}

.textClass {
  display: flex;
  justify-self: left;
  font-size: 18px;

  cursor: pointer;
  border-radius: 35px;
  background-color: #1890ff;
  width: 107px;
  text-align: center;
  justify-content: center;

}

::v-deep .el-button--success {
  background-color: #1890ff;
  border-color: #1890ff;
}

::v-deep .el-button--success:focus, .el-button--success:hover {
  background-color: #1890ff;
  border-color: #1890ff;
}

.no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: auto !important;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;

  width: 50px;
  text-align: center;
  justify-self: right;
  margin-left: auto;
}

.no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin: 30px 10px 10px 0;
  width: 100px;
  text-align: center;
  justify-self: right;
}

.logo {
  display: flex;
  align-content: center;
  //margin-right: -10px;
  flex: 1;
  align-items: center;
  justify-content: left;
  margin-bottom: 20px;
  position: relative;

  .view-count-badge {
    position: absolute;
    right: -100px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 4px 12px;
    border-radius: 20px;
    color: #0e0d0d;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

    i {
      font-size: 16px;
      color: #0e0d0d;
    }

  }
  .img {

    width: 90px;
    height: 90px;
  }
}


.messages {
  display: flex;
  flex-direction: column;
  gap: 65px;
  max-height: 790px;
  overflow: auto;
  //border-width: 2px;
  //border-style: solid;
  //border-color: #77707024;
  margin: 10px 10px 10px 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  //align-items: center;
}

.message-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 10px 10px 10px 10px;
}

.message-item.user {
  flex-direction: row-reverse;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.avatar.bot {
  background-color: #ffffff;
  color: #fff;
}

.avatar.assistant {
  background-color: #fff;
  color: #fff;
}

.avatar.user {
  background-color: #52c41a;
  color: #fff;
}

.message-content {
  max-width: 70%;
  min-width: 200px;
  font-size: 20px;
  margin-bottom: -4px;
}

.message-text {
  padding: 12px 18px;
  border-radius: 8px;
  line-height: 1.5;
  font-size: 20px;
  position: relative;

}

.message-item.bot .message-text {
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.message-item.assistant .message-text {
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  white-space: pre-wrap;
  text-align: left;
}


.message-item.user .message-text {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
}

.message-time {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
  text-align: right;
}

.input-box {
  font-size: 20px;
  color: #232323;
}

.messages-container {
  height: 500px; /* 固定高度 */
  overflow-y: auto; /* 允许垂直滚动 */
  scroll-behavior: smooth; /* 平滑滚动（可选） */
}
.ai-logo{
  width: 50px;
  height: 50px;
}
</style>
